// Campaña de moda
import iconCampañaDeModa from "../assets/Portafolios/Perfile/1.png"
import CampañaDeModaPic1 from "../assets/Portafolios/Preview_campaña_de_moda/1.png"
import CampañaDeModaPic2 from "../assets/Portafolios/Preview_campaña_de_moda/2.png"
import CampañaDeModaPic3 from "../assets/Portafolios/Preview_campaña_de_moda/3.png"
import CampañaDeModaPic4 from "../assets/Portafolios/Preview_campaña_de_moda/4.png"

import crudoModa1 from "../assets/Portafolios/Preview_campaña_de_moda/Crudo/1.jpg"
import crudoModa2 from "../assets/Portafolios/Preview_campaña_de_moda/Crudo/2.jpg"
import crudoModa3 from "../assets/Portafolios/Preview_campaña_de_moda/Crudo/3.jpg"
import crudoModa4 from "../assets/Portafolios/Preview_campaña_de_moda/Crudo/4.jpg"

// MakeUp al aire libre
import iconMakeUpAlAireLibre from "../assets/Portafolios/Perfile/3.png"
import MakeUpAlAireLibrePic1 from "../assets/Portafolios/Preview_Make_al_aire_libre/1.png"
import MakeUpAlAireLibrePic2 from "../assets/Portafolios/Preview_Make_al_aire_libre/2.png"
import MakeUpAlAireLibrePic3 from "../assets/Portafolios/Preview_Make_al_aire_libre/3.png"
import MakeUpAlAireLibrePic4 from "../assets/Portafolios/Preview_Make_al_aire_libre/4.png"

import crudomakeup1 from "../assets/Portafolios/Preview_Make_al_aire_libre/Crudo/1.jpg"
import crudomakeup2 from "../assets/Portafolios/Preview_Make_al_aire_libre/Crudo/2.jpg"
import crudomakeup3 from "../assets/Portafolios/Preview_Make_al_aire_libre/Crudo/3.jpg"
import crudomakeup4 from "../assets/Portafolios/Preview_Make_al_aire_libre/Crudo/4.jpg"

// Campaña fotografica
import iconCampañaFotografica from "../assets/Portafolios/Perfile/2.png"
import CampañaFotograficaPic1 from "../assets/Portafolios/Preview_campaña_forografica/1.png"
import CampañaFotograficaPic2 from "../assets/Portafolios/Preview_campaña_forografica/2.png"
import CampañaFotograficaPic3 from "../assets/Portafolios/Preview_campaña_forografica/3.png"
import CampañaFotograficaPic4 from "../assets/Portafolios/Preview_campaña_forografica/4.png"

import crudoFotografia1 from "../assets/Portafolios/Preview_campaña_forografica/crudo/1.jpg"
import crudoFotografia2 from "../assets/Portafolios/Preview_campaña_forografica/crudo/2.jpg"
import crudoFotografia3 from "../assets/Portafolios/Preview_campaña_forografica/crudo/3.jpg"
import crudoFotografia4 from "../assets/Portafolios/Preview_campaña_forografica/crudo/4.jpg"

// Pestañas
import iconPestañas from "../assets/Portafolios/Perfile/3.png"
import PestañasPic1 from "../assets/Portafolios/Previwe_pestañas/1.png"
import PestañasPic2 from "../assets/Portafolios/Previwe_pestañas/2.png"
import PestañasPic3 from "../assets/Portafolios/Previwe_pestañas/3.png"
import PestañasPic4 from "../assets/Portafolios/Previwe_pestañas/4.png"

import crudoPestañas1 from "../assets/Portafolios/Previwe_pestañas/Crudo/1.jpeg"
import crudoPestañas2 from "../assets/Portafolios/Previwe_pestañas/Crudo/2.jpeg"
import crudoPestañas3 from "../assets/Portafolios/Previwe_pestañas/Crudo/3.jpeg"
import crudoPestañas4 from "../assets/Portafolios/Previwe_pestañas/Crudo/4.jpeg"

// Looks de impacto
import iconLooksDeImpacto from "../assets/Portafolios/Perfile/3.png"
import LookDeImpactoPic1 from "../assets/Portafolios/Preview_look_de_impacto/1.png"
import LookDeImpactoPic2 from "../assets/Portafolios/Preview_look_de_impacto/2.png"
import LookDeImpactoPic3 from "../assets/Portafolios/Preview_look_de_impacto/3.png"
import LookDeImpactoPic4 from "../assets/Portafolios/Preview_look_de_impacto/4.png"

import crudoImpacto1 from "../assets/Portafolios/Preview_look_de_impacto/Crudo/1.jpg"
import crudoImpacto2 from "../assets/Portafolios/Preview_look_de_impacto/Crudo/2.jpg"
import crudoImpacto3 from "../assets/Portafolios/Preview_look_de_impacto/Crudo/3.jpg"
import crudoImpacto4 from "../assets/Portafolios/Preview_look_de_impacto/Crudo/4.jpeg"



const Portafolio = [
    {
        icon: iconCampañaDeModa,
        Title: "Campaña  de moda",
        Texto: "Trabajo junto a Prod. Mariela Reguero @mariela_productora",
        img1: CampañaDeModaPic1,
        img2: CampañaDeModaPic4,
        img3: CampañaDeModaPic2,
        img4: CampañaDeModaPic3,
        min1: crudoModa1,
        min2: crudoModa2,
        min3: crudoModa3,
        min4: crudoModa4,
        id:0
    }, {
        icon: iconMakeUpAlAireLibre,
        Title: "Campañas de fotografia",
        Texto: "Make Up al Aire libre ",
        img1: MakeUpAlAireLibrePic1,
        img2: MakeUpAlAireLibrePic2,
        img3: MakeUpAlAireLibrePic4,
        img4: MakeUpAlAireLibrePic3,
        min1: crudomakeup1,
        min2: crudomakeup2,
        min3: crudomakeup3,
        min4: crudomakeup4,
        id:1

    }, {
        icon: iconCampañaFotografica,
        Title: "Campaña fotografica",
        Texto: "Experiencia realizada junto a Luciano Rojas: @lucianorojas_foto",
        img1: CampañaFotograficaPic1,
        img2: CampañaFotograficaPic2,
        img3: CampañaFotograficaPic3,
        img4: CampañaFotograficaPic4,
        min1: crudoFotografia1,
        min2: crudoFotografia2,
        min3: crudoFotografia3,
        min4: crudoFotografia4,
        id:2

    }, {
        icon: iconPestañas,
        Title: "Pestañas",
        Texto: "Volumen ruso y volumen clásico. ",
        img1: PestañasPic1,
        img2: PestañasPic2,
        img3: PestañasPic3,
        img4: PestañasPic4,
        min1: crudoPestañas1,
        min2: crudoPestañas2,
        min3: crudoPestañas3,
        min4: crudoPestañas4,
        id:3

    }, {
        icon: iconLooksDeImpacto,
        Title: "Looks de impacto",
        Texto: "Trabajos realizados en el curso de AutoMaquillaje inicial",
        img1: LookDeImpactoPic1,
        img2: LookDeImpactoPic2,
        img3: LookDeImpactoPic3,
        img4: LookDeImpactoPic4,
        min1: crudoImpacto1,
        min2: crudoImpacto2,
        min3: crudoImpacto3,
        min4: crudoImpacto4,
        id:4

    }

]

export default Portafolio